import { forwardRef } from 'react';
import format from 'date-fns/format';
import { useTranslation } from 'react-i18next';
import { TextEllipsisWithTooltip } from '__components/Kizen/Table';
import { withCellWrapper, EMPTY_VALUE } from '../helpers';
import { getDataQAForInput } from 'components/Inputs/helpers';
import { useDateTooltip } from 'components/Inputs/hooks/useDateTooltip';
import { toastVariant, useToast } from 'components/ToastProvider';
import { getAdornments } from 'components/Inputs/Adornments/util';
import { useRecordDetailCustomScript } from '@kizenapps/engine/react';
import { WithIconDataAdornments } from 'components/Inputs/Adornments/WithIconDataAdornments';
import { ADORNMENT_VARIANTS } from 'components/Inputs/Adornments/constants';

const _ActualCloseDateCell = forwardRef(
  ({ value, adornments = [], entityId, objectId, field, activityId }, ref) => {
    const [dateTooltipProps, dateTooltip] = useDateTooltip({ date: value });
    const [showToast] = useToast();
    const { t } = useTranslation();
    const dateTimeAdornments = getAdornments(adornments, field);

    const [executeScript, internalState] = useRecordDetailCustomScript({
      entityId,
      objectId,
      onError: (e) => {
        showToast({
          message: `${t('Action could not run')}: ${e?.message}`,
          variant: toastVariant.FAILURE,
        });
      },
    });

    const hasAdornments = dateTimeAdornments.length > 0 && value;

    return (
      <WithIconDataAdornments
        hasAdornments={hasAdornments}
        adornments={dateTimeAdornments}
        scriptArgs={{
          value,
          fieldId: field?.id,
          fieldType: field?.fieldType,
          objectId,
          entityId,
          activityId,
        }}
        disabled={internalState.pending}
        executeScript={executeScript}
        variant={ADORNMENT_VARIANTS.inline}
      >
        <TextEllipsisWithTooltip
          ref={ref}
          {...getDataQAForInput(`inline-record-field-actual_close_date`)}
          {...dateTooltipProps}
        >
          {dateTooltip}
          {value
            ? `${format(value, 'MM/dd/yyyy')} at ${format(value, 'h:mm a')}`
            : EMPTY_VALUE}
        </TextEllipsisWithTooltip>
      </WithIconDataAdornments>
    );
  }
);

export const ActualCloseDateCell = withCellWrapper(_ActualCloseDateCell);
